// Desenho dos itens do cupom de fechamento da mesa (HTML do plano B), um bloco
// por item: linha com quantidade x preço, observação, adicionais (pizza
// agrupada por etapa) e etapas de combo. Tirado de `utils/cupomFechamento.js`.
import { fmtMoeda, medidaDoItem, qtdVezesPreco } from "../../../utils/cupomFormatters";

export function itensHtmlDoCupom(itens, produtosCadastro) {
  let itensHtml = "";
  for (const it of itens) {
    if (it.deleted === true) continue;
    const qty = it.quantidade || it.qty || 1;
    const nome = it.nome || it.name || "Item";
    const preco = it.preco_unitario || it.preco || it.price || 0;
    // `sub.preco` JÁ é o total da linha (unitário x quantidade) — convenção
    // do sistema desde sempre (getItemSubitemsHelper grava `preco: preco * qty`).
    // NÃO multiplicar por quantidade aqui: dobraria o valor.
    const subitemsSum = (it.subitems || []).reduce((s, sub) => s + (Number(sub.preco) || 0), 0);
    const precoBase = Math.max(0, preco - subitemsSum);
    const totalItem = precoBase * qty;
    const precoStr = precoBase.toFixed(2).replace(".", ",");
    const comboTag = (it.combo_type || "").toLowerCase() === "combo" ? " ///COMBO" : "";

    itensHtml += '<div style="margin-bottom:6px;">';
    itensHtml += `<div style="display:flex;justify-content:space-between;"><span>${qtdVezesPreco(qty, precoStr, medidaDoItem(it, produtosCadastro))} ${nome}${comboTag}</span><span>R$ ${fmtMoeda(totalItem)}</span></div>`;
    if ((it.observacao || "").trim())
      itensHtml += `<div style="font-size:12px;font-weight:bold;color:#333;margin-left:8px;">- ${it.observacao}</div>`;
    if (it.subitems && it.subitems.length) {
      const isPizza = it.product_type === "pizza" || !!it.pizza;
      if (isPizza) {
        const groups = {}; const order = [];
        for (const s of it.subitems) {
          const k = (s.step_name || "Itens").toUpperCase();
          if (!groups[k]) { groups[k] = []; order.push(k); }
          groups[k].push(s);
        }
        for (const key of order) {
          itensHtml += `<div style="font-size:11px;font-weight:bold;color:#666;margin-left:8px;margin-top:2px;">${key}:</div>`;
          for (const s of groups[key]) {
            const _sq = Number(s.quantidade ?? s.qty ?? 1) || 1;
              const nm = (_sq > 1 ? `${_sq}x ` : "") + (s.nome || s.name || "");
            const precoSub = Number(s.preco ?? s.price ?? s.preco_unitario ?? 0) || 0;
            const right = precoSub > 0 ? `+R$ ${fmtMoeda(precoSub)}` : "";
            itensHtml += `<div style="display:flex;justify-content:space-between;font-size:12px;font-weight:bold;color:#333;margin-left:16px;"><span>${nm}</span><span>${right}</span></div>`;
          }
        }
      } else {
        for (const s of it.subitems) {
          const _sq = Number(s.quantidade ?? s.qty ?? 1) || 1;
              const nm = (_sq > 1 ? `${_sq}x ` : "") + (s.nome || s.name || "");
          const precoSub = Number(s.preco ?? s.price ?? s.preco_unitario ?? 0) || 0;
          itensHtml += `<div style="display:flex;justify-content:space-between;font-size:12px;font-weight:bold;color:#333;margin-left:12px;"><span>${nm}</span><span>R$ ${fmtMoeda(precoSub)}</span></div>`;
        }
      }
    }
    if ((!it.subitems || !it.subitems.length) && it.etapas && it.etapas.length) {
      for (const ep of it.etapas) {
        const itensEtapa = ep.itens || ep.items || [];
        for (const ei of itensEtapa) {
          const lab = typeof ei === "string" ? ei : (ei.nome || ei.name || "");
          if (!lab) continue;
          const precoEi = typeof ei === "object" && ei != null
            ? (Number(ei.preco ?? ei.price ?? ei.preco_unitario) || 0)
            : null;
          if (precoEi !== null) {
            itensHtml += `<div style="display:flex;justify-content:space-between;font-size:12px;font-weight:bold;color:#333;margin-left:12px;"><span>${lab}</span><span>R$ ${fmtMoeda(precoEi)}</span></div>`;
          } else {
            itensHtml += `<div style="font-size:12px;font-weight:bold;color:#333;margin-left:12px;">${lab}</div>`;
          }
        }
      }
    }
    itensHtml += "</div>";
  }
  return itensHtml;
}
